import { Box, Text } from "@chakra-ui/react";
import { buildSubscriptionInsights } from "./subscriptionInsights";

const SubscriptionSummary = ({ subscriptions = [], reportTypes = [] }) => {
  const summary = buildSubscriptionInsights(subscriptions, reportTypes);
  const active = summary.kpis.find((kpi) => kpi.label === "Active")?.value || "0";
  const paused = summary.kpis.find((kpi) => kpi.label === "Paused")?.value || "0";
  const reportsSelected = summary.kpis.find((kpi) => kpi.label === "Reports Selected")?.value || "0";
  const csvAttachments = summary.kpis.find((kpi) => kpi.label === "CSV Attachments")?.value || "0";
  const widePdfSections = summary.kpis.find((kpi) => kpi.label === "Wide PDF Sections")?.value || "0";

  return (
    <Box className="subscriptionOverview" mb="20px">
      <Box className="subscriptionOverviewHeader">
        <Text as="h3">Delivery overview</Text>
        <Text>Configured report deliveries for this organization.</Text>
      </Box>
      <Box className="subscriptionOverviewGrid">
        <Box>
          <Text>Active</Text>
          <strong>{active}</strong>
        </Box>
        <Box>
          <Text>Paused</Text>
          <strong>{paused}</strong>
        </Box>
        <Box>
          <Text>Reports selected</Text>
          <strong>{reportsSelected}</strong>
        </Box>
        <Box>
          <Text>CSV attachments</Text>
          <strong>{csvAttachments}</strong>
        </Box>
        <Box>
          <Text>Landscape PDFs</Text>
          <strong>{widePdfSections}</strong>
        </Box>
      </Box>
      {summary.notes.length ? (
        <Text className="subscriptionOverviewNote">{summary.notes.join(" ")}</Text>
      ) : null}
    </Box>
  );
};

export default SubscriptionSummary;
